// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kit/score/score.proto (package score, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kit/score/score.proto.
 */
export const file_kit_score_score: GenFile = /*@__PURE__*/
  fileDesc("ChVraXQvc2NvcmUvc2NvcmUucHJvdG8SBXNjb3JlItkBCgVTY29yZRIKCgJJRBgBIAEoBBIUCgxTdWJtaXNzaW9uSUQYAiABKAQSDgoGU2VjcmV0GAMgASgJEhAKCFRlc3ROYW1lGAQgASgJEg0KBVNjb3JlGAUgASgFEhAKCE1heFNjb3JlGAYgASgFEg4KBldlaWdodBgHIAEoBRITCgtUZXN0RGV0YWlscxgIIAEoCRISCgpUZXN0T3V0cHV0GAkgASgJEiEKBlN0YXR1cxgKIAEoDjIRLnNjb3JlLlRlc3RTdGF0dXMSDwoHRWxhcHNlZBgLIAEoASLWAQoJQnVpbGRJbmZvEgoKAklEGAEgASgEEhQKDFN1Ym1pc3Npb25JRBgCIAEoBBIQCghCdWlsZExvZxgDIAEoCRIQCghFeGVjVGltZRgEIAEoAxItCglCdWlsZERhdGUYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjIKDlN1Ym1pc3Npb25EYXRlGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIgCgZTdGF0dXMYByABKA4yEC5zY29yZS5SdW5TdGF0dXMqPgoKVGVzdFN0YXR1cxILCgdOT1RfUlVOEAASCgoGUEFTU0VEEAESCgoGRkFJTEVEEAISCwoHU0tJUFBFRBADKlcKCVJ1blN0YXR1cxILCgdTVUNDRVNTEAASEQoNQlVJTERfRkFJTFVSRRABEgsKB1RJTUVPVVQQAhINCglOT19TQ09SRVMQAxIOCgpURVNUX1BBTklDEARCKlooZ2l0aHViLmNvbS9xdWlja2ZlZWQvcXVpY2tmZWVkL2tpdC9zY29yZWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Score give the score for a single test named TestName.
 *
 * @generated from message score.Score
 */
export type Score = Message<"score.Score"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: uint64 SubmissionID = 2;
   */
  SubmissionID: bigint;

  /**
   * the unique identifier for a scoring session
   *
   * @generated from field: string Secret = 3;
   */
  Secret: string;

  /**
   * name of the test
   *
   * @generated from field: string TestName = 4;
   */
  TestName: string;

  /**
   * the score obtained
   *
   * @generated from field: int32 Score = 5;
   */
  Score: number;

  /**
   * max score possible to get on this specific test
   *
   * @generated from field: int32 MaxScore = 6;
   */
  MaxScore: number;

  /**
   * the weight of this test; used to compute final grade
   *
   * @generated from field: int32 Weight = 7;
   */
  Weight: number;

  /**
   * failure diagnostics reported by the score library or test framework
   *
   * @generated from field: string TestDetails = 8;
   */
  TestDetails: string;

  /**
   * other output from the test or the implementation it exercises
   *
   * @generated from field: string TestOutput = 9;
   */
  TestOutput: string;

  /**
   * outcome reported by the test framework
   *
   * @generated from field: score.TestStatus Status = 10;
   */
  Status: TestStatus;

  /**
   * seconds the test took to run
   *
   * @generated from field: double Elapsed = 11;
   */
  Elapsed: number;
};

/**
 * Describes the message score.Score.
 * Use `create(ScoreSchema)` to create a new message.
 */
export const ScoreSchema: GenMessage<Score> = /*@__PURE__*/
  messageDesc(file_kit_score_score, 0);

/**
 * BuildInfo holds build data for an assignment's test execution.
 *
 * @generated from message score.BuildInfo
 */
export type BuildInfo = Message<"score.BuildInfo"> & {
  /**
   * @generated from field: uint64 ID = 1;
   */
  ID: bigint;

  /**
   * @generated from field: uint64 SubmissionID = 2;
   */
  SubmissionID: bigint;

  /**
   * @generated from field: string BuildLog = 3;
   */
  BuildLog: string;

  /**
   * @generated from field: int64 ExecTime = 4;
   */
  ExecTime: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp BuildDate = 5;
   */
  BuildDate?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp SubmissionDate = 6;
   */
  SubmissionDate?: Timestamp | undefined;

  /**
   * outcome of the test run
   *
   * @generated from field: score.RunStatus Status = 7;
   */
  Status: RunStatus;
};

/**
 * Describes the message score.BuildInfo.
 * Use `create(BuildInfoSchema)` to create a new message.
 */
export const BuildInfoSchema: GenMessage<BuildInfo> = /*@__PURE__*/
  messageDesc(file_kit_score_score, 1);

/**
 * TestStatus is the outcome the test framework reported for a single test.
 * It is independent of the score: a test may fail while holding partial credit,
 * and may pass while scoring below its max score.
 *
 * @generated from enum score.TestStatus
 */
export enum TestStatus {
  /**
   * the run recorded no outcome for this test
   *
   * @generated from enum value: NOT_RUN = 0;
   */
  NOT_RUN = 0,

  /**
   * the test ran to completion without failing
   *
   * @generated from enum value: PASSED = 1;
   */
  PASSED = 1,

  /**
   * the test reported a failure
   *
   * @generated from enum value: FAILED = 2;
   */
  FAILED = 2,

  /**
   * the test was skipped
   *
   * @generated from enum value: SKIPPED = 3;
   */
  SKIPPED = 3,
}

/**
 * Describes the enum score.TestStatus.
 */
export const TestStatusSchema: GenEnum<TestStatus> = /*@__PURE__*/
  enumDesc(file_kit_score_score, 0);

/**
 * RunStatus classifies the outcome of a test run. BUILD_FAILURE records
 * trustworthy zero scores; the other failure statuses keep previous scores.
 *
 * @generated from enum score.RunStatus
 */
export enum RunStatus {
  /**
   * the run produced test results
   *
   * @generated from enum value: SUCCESS = 0;
   */
  SUCCESS = 0,

  /**
   * the submitted code failed to compile or build
   *
   * @generated from enum value: BUILD_FAILURE = 1;
   */
  BUILD_FAILURE = 1,

  /**
   * the run exceeded the assignment's container timeout
   *
   * @generated from enum value: TIMEOUT = 2;
   */
  TIMEOUT = 2,

  /**
   * the run produced no parsable test scores
   *
   * @generated from enum value: NO_SCORES = 3;
   */
  NO_SCORES = 3,

  /**
   * the test execution panicked before producing test scores
   *
   * @generated from enum value: TEST_PANIC = 4;
   */
  TEST_PANIC = 4,
}

/**
 * Describes the enum score.RunStatus.
 */
export const RunStatusSchema: GenEnum<RunStatus> = /*@__PURE__*/
  enumDesc(file_kit_score_score, 1);

